import { CSSProperties, KeyboardEvent, PropsWithChildren, useState } from 'react';
import { cn } from '@ds';
import styles from '../../CaseCard.module.scss';
import { KidneyBananaTop, KidneyBananaBottom, BananaTrigger, BANANA_CARD_VISIBLE } from './BananaDecor';
import { OrganType } from '@/api/apis/case';

type CardLayoutProps = {
  color: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  isCandidateCard?: boolean;
  organType?: OrganType;
  style?: CSSProperties;
  onClick?: () => void;
};

export const CardLayout = ({
  color,
  style,
  isSelected = false,
  isDisabled = false,
  isCandidateCard = false,
  organType,
  onClick,
  children,
}: CardLayoutProps & PropsWithChildren) => {
  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      onClick?.();
    }
  };

  const borderColorClassName = isCandidateCard ? 'border-base-10' : 'border-base-30';
  const hoverBorderColorClassName = isCandidateCard ? 'hover:border-base-10' : 'hover:border-base-30';
  const [isBananaMode, setIsBananaMode] = useState(false);
  const bananaEligible = organType === OrganType.Kidney && BANANA_CARD_VISIBLE;
  const showBananaDecor = bananaEligible && isBananaMode;

  return (
    <div
      style={style}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
      onClick={onClick}
      className={cn(
        styles.cardLayout,
        color,
        'flex-1 border-1 border-transparent text-base-5 text-left cursor-pointer hover:border-base-30',
        {
          'h-full': isCandidateCard,
          'opacity-50 pointer-events-none': isDisabled,
          [borderColorClassName]: isSelected,
          [styles.kidneyCard]: showBananaDecor,
        },
        hoverBorderColorClassName,
      )}
    >
      {bananaEligible && !isBananaMode && <BananaTrigger onActivate={() => setIsBananaMode(true)} />}
      {showBananaDecor && <KidneyBananaTop />}
      {children}
      {showBananaDecor && <KidneyBananaBottom onDeactivate={() => setIsBananaMode(false)} />}
    </div>
  );
};
